namespace app.documentos {
    import IScope = angular.IScope;
    import IQService = angular.IQService;
    import IIntervalService = angular.IIntervalService;
    import IPromise = angular.IPromise;
    import IDeferred = angular.IDeferred;
    import AuthService = app.autenticacao.AuthService;
    import IUser = app.autenticacao.IUser;

    export class EditorController {

        showEditor: boolean = true;
        showProgress: boolean = false;
        edicaoIniciada: boolean = false;
        documento: EditorDocumento;
        config: DocumentConfig;
        contexto: string;
        api: OnlyofficeDirectiveApi;

        /** @ngInject **/
        constructor(private $q: IQService, private $interval: IIntervalService,
                private $scope: EditorScope, private onlyofficeService: OnlyofficeService,
                private authService: AuthService) {
            this.documento = $scope.documento;
            this.contexto = $scope.contexto;

            if (!this.documento.id && !this.documento.textoId) {
                throw new Error("O id do documento ou do texto deve ser especificado!");
            }

            $scope.api = {
                salvar: () => {
                    if (this.$scope.readOnly) {
                        return this.$q.when();
                    }                    
                    return this.api.plugin("save-sync").call("save").then((data) => {
                        if ($scope.aguardarConclusao == "true") {
                            this.showEditor = false;
                            this.showProgress = true;
                            return this.verificarEdicaoCompleta().then(
                                () => $scope.edicaoConcluida(), 
                                () => {
                                    this.showEditor = true;
                                    this.showProgress = false;
                                    $scope.edicaoTimeout();
                                    return this.$q.reject();
                            });                            
                        } else if ($scope.aguardarConclusao == "false") {
                            $scope.edicaoConcluida();
                            return this.$q.when({});
                        }
                    });
                },
                plugin: (name: string): OnlyofficePluginApi => {
                    return this.api.plugin(name);
                }
            };

            if (!this.documento.id && this.documento.textoId) {
                this.onlyofficeService.recuperarDocumentoId(this.documento.textoId, this.contexto)
                    .then((documentoId: number) => {
                        this.documento.id = documentoId;
                        this.configurarEditor();
                    });
            } else {
                this.configurarEditor();
            }
        }

        private configurarEditor() {
            this.authService.getUser().then((usuario) => {
                if (this.$scope.readOnly) {
                    this.iniciarEditor(null, usuario);
                } else {
                    this.onlyofficeService.gerarNumeroEdicao(this.documento.id, this.documento.temporario, this.contexto)
                        .then((edicao) => this.iniciarEditor(edicao.numero, usuario));
                }
            });
        }

        private iniciarEditor(numeroEdicao: string, usuario: IUser) {
            this.$q.all([this.onlyofficeService
                             .criarUrlConteudoDocumento(this.documento.id, this.documento.temporario, this.contexto),
                        this.onlyofficeService
                            .recuperarUrlCallback(this.documento.id, this.documento.temporario, this.$scope.save,
                                    this.contexto, this.$scope.callbackOmitToken),
                        this.onlyofficeService
                            .recuperarUrlPlugins(this.contexto)])
                .then((urls) => {
                    this.config = {
                        editorConfig : {
                            lang: 'pt-BR',
                            customization: {
                                about: true,
                                chat: true,
                                compactToolbar: false
                            },
                            mode: this.$scope.readOnly ? "view" : "edit",
                            user: {
                                id: usuario.login,
                                name: usuario.nome
                            },
                            plugins: this.buildPluginConfig(urls[2], this.$scope.plugins)
                        },
                        document: {
                            id: this.documento.id,
                            src: urls[0],
                            key: numeroEdicao,
                            name: this.documento.nome,
                            callbackUrl: this.$scope.readOnly ? undefined : urls[1],
                            temp: this.documento.temporario ? true : false
                        }
                    };
                    this.verificarEdicaoIniciada().then(() => {
                        this.edicaoIniciada = true;
                        this.$scope.edicaoIniciada();
                    });
                });
        }
        
        private buildPluginConfig(urlPlugins: string, plugins) {
            let pluginsConfig: DocsAPI.OnlyofficePluginsConfig = {
                autostart: [],
                pluginsData: [],
                pluginsParams: []
            };

            pluginsConfig.pluginsData.push(urlPlugins + "/save-sync/config.json");
            
            if (plugins) {
                for (let plugin of plugins) {
                    pluginsConfig.pluginsData.push(urlPlugins + "/" + plugin.id + "/config.json");
                    if (plugin.autostart) {
                        pluginsConfig.autostart.push(plugin.autostart.guid);
                    }
                    pluginsConfig.pluginsParams.push({
                        id: plugin.id,
                        params: plugin.params
                    });
                }
            }
            
            return pluginsConfig;
        }

        private tentativasVerificaoEdicaoCompleta: number = 0;
        private deferredEdicaoCompleta: IDeferred<{}>;

        private verificarEdicaoCompleta(): IPromise<{}> {
            this.tentativasVerificaoEdicaoCompleta = 0;
            this.deferredEdicaoCompleta = this.$q.defer();
            this.iteracaoVerificarEdicaoCompleta();
            return this.deferredEdicaoCompleta.promise;
        }

        private iteracaoVerificarEdicaoCompleta() {
            if (this.$scope.readOnly) {
                return this.deferredEdicaoCompleta.resolve();
            }
            this.onlyofficeService.recuperarNumeroEdicao(this.documento.id, this.documento.temporario, this.contexto)
                .then((edicao) => {
                    console.info(edicao);
                    if (this.tentativasVerificaoEdicaoCompleta % 5 === 0) {
                        this.onlyofficeService.removerUsuariosEdicao(edicao, this.contexto);
                    }
                    this.tentativasVerificaoEdicaoCompleta++;
                    if (this.tentativasVerificaoEdicaoCompleta < 20) {
                        this.$interval(() => this.iteracaoVerificarEdicaoCompleta(), 1000, 1);
                    } else {
                        this.deferredEdicaoCompleta.reject();
                    }
                }, (edicao) => {
                    console.info(edicao);
                    if (edicao.status === 404) {
                        this.deferredEdicaoCompleta.resolve();
                    } else {
                        this.deferredEdicaoCompleta.reject();
                    }
                });
        }

        private tentativasVerificaoEdicaoIniciada: number = 0;
        private deferredEdicaoIniciada: IDeferred<{}>;

        private verificarEdicaoIniciada(): IPromise<{}> {
            this.tentativasVerificaoEdicaoIniciada = 0;
            this.deferredEdicaoIniciada = this.$q.defer();
            this.iteracaoVerificarEdicaoIniciada();
            return this.deferredEdicaoIniciada.promise;
        }

        private iteracaoVerificarEdicaoIniciada() {
            if (this.$scope.readOnly) {
                return this.deferredEdicaoIniciada.resolve();
            }
            this.onlyofficeService.recuperarNumeroEdicao(this.documento.id, this.documento.temporario, this.contexto)
                .then((edicao) => {
                    console.info(edicao);
                    if (edicao.ativo) {
                        this.deferredEdicaoIniciada.resolve();
                    } else {
                        this.tratarNaoAtivo();
                    }
                }, (edicao) => {
                    console.info(edicao);
                    this.tratarNaoAtivo();
                });
        }

        private tratarNaoAtivo() {
            this.tentativasVerificaoEdicaoIniciada++;
            if (this.tentativasVerificaoEdicaoIniciada < 20) {
                this.$interval(() => this.iteracaoVerificarEdicaoIniciada(), 1000, 1);
            } else {
                this.deferredEdicaoIniciada.reject();
            }
        }

    }
    angular.module('app.documentos').controller('app.documentos.EditorController', EditorController);
}